/** @jsx jsx */
import React, { useState } from 'react';
import { jsx } from '@emotion/core';
import { Grid, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { CustomDialog } from 'components';
import * as S from './styles';
import MobileSorting from './MobileSorting';
import { ICustomTheme } from 'interfaces';

const MobileFilterLayout = ({
  openDialog,
  setOpenDialog,
  children,
}: {
  children: React.ReactChild;
  openDialog: any;
  setOpenDialog: any;
}): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const { t } = useTranslation();
  const [openSortingDialog, setOpenSortingDialog] = useState(false);

  const handleClose = (setOpen: (bool: boolean) => void) => {
    setOpen(false);
  };

  return (
    <div css={{ marginBottom: theme.spacing(3) }}>
      <Grid container>
        <Grid item xs={6}>
          <S.CustomButton
            onClick={() => setOpenDialog(true)}
            variant="contained"
            fullWidth
            backgroundColor={theme.colors.paletteFromBO.main}
          >
            {t('challenges.declaration.filter')}
          </S.CustomButton>
        </Grid>
        <Grid item xs={6}>
          <S.CustomButton
            onClick={() => setOpenSortingDialog(true)}
            variant="contained"
            fullWidth
            backgroundColor={theme.colors.paletteFromBO.secondary}
          >
            {t('challenges.declaration.display')}
          </S.CustomButton>
        </Grid>
      </Grid>
      {/* ----- MODAL FILTER ------ */}
      <Grid container>
        <CustomDialog
          title={t('challenges.declaration.filter')}
          open={openDialog}
          handleClose={() => handleClose(setOpenDialog)}
        >
          {children}
        </CustomDialog>
      </Grid>
      {/* ----- MODAL SORTING ------ */}
      <Grid container>
        <CustomDialog
          title={t('challenges.declaration.filter')}
          open={openSortingDialog}
          handleClose={() => handleClose(setOpenSortingDialog)}
        >
          <MobileSorting onConfirm={() => setOpenSortingDialog(false)} />
        </CustomDialog>
      </Grid>
    </div>
  );
};

export default MobileFilterLayout;
